import { FlexView, Row, Col, COLORS } from '@cuemath/comps';
import React from 'react';
import useLogic from './TeacherPerformance.logic';
import styled from 'styled-components';
import { Separator, Text } from '@cuemath/web-comps';
import {
  TEACHER_PERFORMANCE_STATES_CONFIG,
  RETENTION_STATUS_FILTER_OPTIONS,
} from 'constants/teacher-details';
import { Table, TableCell } from 'comps';
import { Dropdown, TableRow } from 'semantic-ui-react';

const RetentionRateWrapper = styled(FlexView)`
  border-radius: 4px;
  background: ${({ background }) => background ?? COLORS.BG_CLOUD};
`;

const StyledTableCell = styled(TableCell)`
  cursor: pointer;
`;

const TableWrapper = styled(FlexView)`
  max-height: 650px;
  overflow: auto;
`;

const TeacherPerformance = () => {
  const {
    retentionHistory,
    isLoading,
    tableFilter,
    handleFilterChange,
    filteredStudents,
  } = useLogic();
  const { cycle, performanceState, retentionRate, month } = retentionHistory ?? {};
  const currentConfig = TEACHER_PERFORMANCE_STATES_CONFIG?.[performanceState];

  return (
    <FlexView>
      <Row justifyContent="space-between" alignItems="center" gutter={0}>
        <Col gutter={0}>
          <Text variant="h6">{`Month: ${month ?? '--'}`}</Text>
        </Col>
        <Col gutter={0}>
          <Text variant="h6">{`Cycle: ${cycle ?? '--'}`}</Text>
        </Col>
        <Col gutter={0}>
          {!currentConfig?.hideRetentionRate && retentionRate && (
            <Row alignItems="center">
              <Col gutter={8}>
                <Text variant="h6">Retention rate:</Text>
              </Col>
              <Col gutter={0}>
                <RetentionRateWrapper
                  background={currentConfig?.bgColor}
                  gutter={8}
                  gap={8}
                >
                  <Text variant="h6" color={currentConfig?.color}>
                    {retentionRate ?? ''}%
                  </Text>
                </RetentionRateWrapper>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
      <Separator height={16} />
      <TableWrapper>
        <Table
          headerCell={[
            { title: 'id' },
            { title: 'Student name' },
            { title: 'Grade' },
            { title: 'Region' },
            { title: 'Enrollment Type' },
            { title: 'Last class on' },
            { title: '# classes in last 12 months' },
            {
              title: 'Status',
              filterApplied: tableFilter?.status?.length > 0,
              filterComponent: (
                <Dropdown
                  clearable
                  fluid
                  multiple
                  onChange={(_, data) => {
                    handleFilterChange('status', data?.value);
                  }}
                  options={RETENTION_STATUS_FILTER_OPTIONS}
                  placeholder="Select Status"
                  search
                  selection
                  value={tableFilter?.status}
                />
              ),
              showFilters: true,
            },
            { title: 'Comment' },
          ]}
          dataLength={filteredStudents?.length || 0}
          showInfo={false}
          showLoader={isLoading}
        >
          {filteredStudents?.map(
            ({
              id,
              name,
              grade,
              region,
              enrollmentType,
              statusLabel,
              lastClassOn,
              classesCount,
              comment,
            }) => (
              <TableRow>
                <StyledTableCell
                  width={2}
                  onClick={() => {
                    if (!id) return () => {};
                    return window.open(`/students/${id}`, '_blank');
                  }}
                >
                  {id || '-'}
                </StyledTableCell>
                <StyledTableCell
                  width={2}
                  onClick={() => {
                    if (!id) return () => {};
                    return window.open(`/students/${id}`, '_blank');
                  }}
                >
                  {name || '-'}
                </StyledTableCell>
                <TableCell width={1}>{grade || '-'}</TableCell>
                <TableCell width={1}>{region || '-'}</TableCell>
                <TableCell width={1}>{enrollmentType || '-'}</TableCell>
                <TableCell width={1}>{lastClassOn || '-'}</TableCell>
                <TableCell width={1}>{classesCount || '-'}</TableCell>
                <TableCell width={1}>{statusLabel || '-'}</TableCell>
                <TableCell width={1}>{comment || '-'}</TableCell>
              </TableRow>
            ),
          )}
        </Table>
      </TableWrapper>
    </FlexView>
  );
};

export default TeacherPerformance;
